var _rect, _rect2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePickerEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 135,
    viewBox: "0 0 240 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 135,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 135,
    rx: 10,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 135,
    rx: 10,
    fill: "url(#paint0_radial_7758_127963)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.925 59.5449C126.987 59.5449 128.729 57.718 128.729 55.3544C128.729 53.0472 126.978 51.2769 124.925 51.2769C122.882 51.2769 121.121 53.0755 121.13 55.3732C121.13 57.718 122.863 59.5449 124.925 59.5449ZM114.039 59.7614C115.838 59.7614 117.354 58.1606 117.354 56.1077C117.354 54.0925 115.819 52.5575 114.039 52.5575C112.259 52.5575 110.724 54.1207 110.734 56.1265C110.734 58.1606 112.25 59.7614 114.039 59.7614ZM108.851 68.3119H115.913C114.906 66.8712 115.988 64.0273 118.117 62.3511C117.081 61.6825 115.734 61.1928 114.039 61.1928C109.83 61.1928 107.108 64.2909 107.108 66.8429C107.108 67.7752 107.579 68.3119 108.851 68.3119ZM119.058 68.3025H130.792C132.346 68.3025 132.882 67.8317 132.882 66.9653C132.882 64.5452 129.803 61.2116 124.925 61.2116C120.038 61.2116 116.968 64.5452 116.968 66.9653C116.968 67.8317 117.505 68.3025 119.058 68.3025Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7758_127963)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4609 119.29L41.5575 114.045C57.4138 108.8 89.6069 98.3107 121.56 107.052C153.513 115.793 174.405 130.371 217.658 130.371C260.912 130.371 281.804 119.29 297.661 114.045L313.757 92.6223L313.757 192.717L297.661 192.717C281.804 192.717 249.611 192.717 217.658 192.717C185.706 192.717 153.513 192.717 121.56 192.717C89.6069 192.717 57.4138 192.717 41.5575 192.717L25.4609 192.717L25.4609 119.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.036 121.807L265.939 116.563C250.083 111.318 217.89 100.828 185.937 109.57C153.984 118.311 133.092 132.889 89.8381 132.889C46.5841 132.889 25.6922 121.807 9.83584 116.563L-6.26068 95.1398L-6.26069 195.234L9.83584 195.234C25.6922 195.234 57.8852 195.234 89.8381 195.234C121.791 195.234 153.984 195.234 185.937 195.234C217.89 195.234 250.083 195.234 265.939 195.234L282.036 195.234L282.036 121.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-10.4346 121.807L5.67024 116.563C21.5347 111.318 53.7443 100.828 85.7136 109.57C117.683 118.311 138.586 132.889 181.862 132.889C225.138 132.889 246.041 121.807 261.905 116.563L278.01 95.1398L278.01 195.234L261.905 195.234C246.041 195.234 213.831 195.234 181.862 195.234C149.892 195.234 117.683 195.234 85.7136 195.234C53.7443 195.234 21.5347 195.234 5.67025 195.234L-10.4346 195.234L-10.4346 121.807Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7758_127963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.5217 62.2917) rotate(29.6283) scale(120.524 213.702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B40ED",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B40ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7758_127963"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 75H240V125C240 130.523 235.523 135 230 135H10C4.47716 135 0 130.523 0 125V75Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePickerEmpty);
export default __webpack_public_path__ + "static/media/image-picker-empty.60150bca62b6464468333db9f3eef57c.svg";
export { ForwardRef as ReactComponent };